import { render } from "./ServiceToDoList.modal.vue?vue&type=template&id=249373c3"
import script from "./ServiceToDoList.modal.vue?vue&type=script&lang=js"
export * from "./ServiceToDoList.modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__